export const getNotificationsItems = (state) => state.notifications?.items || [];
export const getNotificationsLoading = (state) =>
  Boolean(state.notifications?.loading);
